import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

import type {
    GetAppDefinitionCatalog,
    GetAppDefinition,
    GetAppDefinition_sync,
    IAppDefinitionPayload,
} from './platformAppDefinitionQueries';
import type { AppDefinition } from 'owa-graph-schema';
import type { MailboxInfo } from 'owa-client-types';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AppDefinitions" */ './lazyIndex'),
    { name: 'AppDefinitions' }
);

export const lazyGetAppDefinition: LazyAction<
    (
        appId: string,
        skipCache?: boolean,
        mailboxInfo?: MailboxInfo
    ) => Promise<IAppDefinitionPayload>,
    LazyModule<typeof lazyIndex>
> = new LazyAction<GetAppDefinition, typeof lazyModule>(lazyModule, m => m.getAppDefinition);

export const lazyGetAppDefinition_sync: LazyAction<
    (appId: string, mailboxInfo?: MailboxInfo) => IAppDefinitionPayload | undefined,
    LazyModule<typeof lazyIndex>
> = new LazyAction<GetAppDefinition_sync, typeof lazyModule>(
    lazyModule,
    m => m.getAppDefinition_sync
);

export const lazyGetAppDefinitionCatalog: LazyAction<
    (
        fetchPolicy?: 'cache-first' | 'network-only' | 'cache-only' | 'static-only',
        mailboxInfo?: MailboxInfo
    ) => Promise<AppDefinition[]>,
    LazyModule<typeof lazyIndex>
> = new LazyAction<GetAppDefinitionCatalog, typeof lazyModule>(
    lazyModule,
    m => m.getAppDefinitionCatalog
);
